<template>
<div>
  <v-footer
    padless
    fixed
    dark
    color="blueDark">
        <div class="font-weight-thin mr-5 grey--text">
            v {{version}}
        </div>
        <v-spacer></v-spacer>
        <div>&copy; {{new Date().getFullYear()}}</div>
  </v-footer>
</div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';
export default {
  name: 'Footer',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['version']),
  },
  methods: {
    ...mapMutations([]),
},
}

</script>

